<template>
    <div>
        <div id="mySidenav" class="sidenav fixed grey lighten-4 text-dark" :class="slim">
            <ul class="custom-scrollbar ps ps--theme_default" data-ps-id="e1b5f787-914a-065d-9c55-e36e950e82cc">
                <li class="logo-sn waves-effect py-3">
                    <div class="text-center">
                        <!-- <img id="main-logo" class="d-inline-block align-top mr-1" width="120" :src="logo" alt="logo"> -->
                    </div>
                </li>
                <li>
                    <div class="accordion" id="accordionExample">
                        <!-- <div class="menu-item" id="headingOne2">
                            <a style="font-size: small !important;" href="#/dashboard" @click="changeView('stats')"
                                class="collapsible-header collapsible-header-custom waves-effect active arrow-r"
                                data-toggle="collapse" data-target="#collapseOne2" aria-expanded="false"
                                aria-controls="collapseOne2"><i class="fas fa-chart-pie mr-3"></i><span
                                    :style="hideArrows ? 'display:none;' : ''">Estadisticas<i
                                        class="fas fa-angle-right my-0"></i></span>
                            </a>
                        </div> -->
                        <!-- <div id="collapseOne2" class="collapse px-3 menu-item" aria-labelledby="headingOne2"
                            data-parent="#accordionExample"></div>
                        <div class="menu-item" id="headingOne3">
                            <a style="font-size: small !important;" href="#/dashboard" @click="changeView('users')"
                                class="collapsible-header collapsible-header-custom waves-effect arrow-r"
                                data-toggle="collapse" data-target="#collapseOne3" aria-expanded="false"
                                aria-controls="collapseOne3">
                                <i class="fas fa-user-cog mr-3"></i><span
                                    :style="hideArrows ? 'display:none;' : ''">Usuarios<i
                                        class="fas fa-angle-right my-0"></i></span>
                            </a>
                        </div> -->
                        <div id="collapseOne3" class="collapse px-3 menu-item" aria-labelledby="headingOne3"
                            data-parent="#accordionExample"></div>
                        <div class="menu-item">
                            <div class="" id="headingOne">
                                <a style="font-size: small !important;"
                                    class="collapsible-header collapsible-header-custom waves-effect arrow-r"
                                    data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                    aria-controls="collapseOne">
                                    <i class="fas fa-brain mr-3"></i>
                                    <span
                                    :style="hideArrows ? 'display:none;' : ''">Reportes Globales<i
                                        class="my-0 fas fa-angle-down rotate-icon"></i></span>
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse px-3" aria-labelledby="headingOne"
                                data-parent="#accordionExample">
                                <ul>
                                    <!-- CONDITION ReportGlobal BEGIN -->
                                    <li>
                                        <a style="font-size: small !important;" href="#/dashboard" class="waves-effect"
                                            @click="changeView('reporteAgente')">
                                            Reporte por Página<i class="fas fa-angle-right m-0"></i>
                                        </a>
                                    </li>
                                    <!-- CONDITION ReportGlobal END -->
                                    <!-- CONDITION ReportGlobalPlayer BEGIN -->
                                    <!-- <li>
                                        <a style="font-size: small !important;" href="#/dashboard" class="waves-effect"
                                            @click="changeView('reporteJugador')">
                                            Reporte por Jugador<i class="my-0 fas fa-angle-right"></i>
                                        </a>
                                    </li> -->
                                    <!-- CONDITION ReportGlobalPlayer END -->
                                </ul>
                            </div>
                        </div>
                        
                        <!-- CONDITION FinanceAffiliatesOwnBalance END -->

                <li>
                    <a style="font-size: small !important;" v-if="screen_width > 1000" id="toggle"
                        class="collapsible-header waves-effect" @click="viewType == 'thin' ? closeNav() : openNav()">
                        <i class="fas fa-angle-double-left mx-2"></i>Plegar Menu
                    </a>
                </li>
                <div class="" id="headingOne5" style="visibility: hidden;">
                    <a id="closeAll" style="font-size: small !important;" href="#/dashboard"
                        class="collapsible-header waves-effect" data-toggle="collapse" data-target="#collapseOne5"
                        aria-expanded="false" aria-controls="collapseOne5"> Close
                    </a>
                </div>
                <div id="collapseOne5" class="collapse px-3" aria-labelledby="headingOne5" data-parent="#accordionExample">
                </div>
        </div>
        </li>
        </ul>
        <div class="sidenav-bg mask-strong"></div>
    </div>
    <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar double-nav grey lighten-4">
        <div class="">
            <span data-activates="slide-out2" class="button-collapse black-text float-left m-0 p-0" @click="openNav">
                <i class="fas fa-bars"></i>
            </span>
        </div>
        <div class="breadcrumb-dn mr-auto"></div>
        <ul class="nav nav-custom navbar-nav nav-flex-icons ml-auto">
            <li class="nav-item dropdown user-custom-dropdown">
                <a class="nav-link dropdown-toggle waves-effect black-text" href="#" id="userDropdown"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-user-secret"></i>
                    <span class="clearfix d-none d-sm-inline-block own-username">{{ UserData.name }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                    <!-- CONDITION ChangeOwnPassword BEGIN -->
                    <a class="dropdown-item waves-effect waves-light" href="#" id="ChangeOwnPassword" data-user-id=""
                        @click="openModal('ModalChangePassword1')">Cambiar Contraseña</a>
                    <!-- CONDITION ChangeOwnPassword END -->

                    <!-- <a class="dropdown-item waves-effect waves-light" href="#" id="ChangeLanguage">Cambiar Idioma</a> -->
                    <a class="dropdown-item waves-effect waves-light" @click="openModal('historial_ingresos')" href="#"
                        id="LoginHistory" data-bs-toggle="modal" data-bs-target="#historial_ingresos">Historial de
                        Ingresos</a>
                    <!-- CONDITION SupportMyAccount BEGIN -->
                    <!-- CONDITION BrandRegister BEGIN -->
                    <a class="dropdown-item waves-effect waves-light" href="#" id="MyAccount">Mi cuenta</a>
                    <!-- CONDITION BrandRegister END -->
                    <!-- CONDITION SupportMyAccount END -->
                    <a class="dropdown-item waves-effect waves-light" @click="logout" href="#">Salir</a>
                </div>
            </li>
        </ul>
    </nav>
    <div style="padding-top: 3.5rem!important;" :style="screen_width > 1000 ? 'margin-left:6%' : ''">
        <!-- <stats v-if="getActualView == 'stats' && reloadStats" :view_type="viewType" /> -->
        <reporteAgente v-if="getActualView == 'reporteAgente'" :view_type="viewType" />
    </div>
    <div class="modal fade show" id="ModalChangePassword1" tabindex="-1" role="dialog" aria-labelledby="ChangePassword"
        aria-modal="true">
        <div class="modal-dialog cascading-modal modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header text-center gradient-card-header blue-gradient">
                    <h6 class="modal-title w-100 font-weight-bold text-left ml-2">Cambiar Contraseña</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="showChangePassword" class="font-size-custom py-2" id="">Para
                        preversar la seguridad de su cuenta, le aconsejamos cambiar su
                        contraseña.</div>
                    <div class="md-form pb-2 font-size-custom">
                        <i class="fas fa-eye prefix change-password-reveal grey-text" id="iconPassMain1" title="Mostrar"
                            @click="showHidePassword('ChangePasswordNewMain', 'iconPassMain1', 1)"></i>
                        <input type="password" v-model="new_password" id="ChangePasswordNewMain"
                            class="form-control change-password-toggle change-password-input modal-clear-val"
                            maxlength="16">
                        <label for="ChangePasswordNewMain" class="">Nueva Contraseña</label>
                    </div>
                    <div class="md-form pb-2 font-size-custom">
                        <i class="fas fa-eye prefix change-password-reveal grey-text" id="iconPassMain2" title="mostrar"
                            @click="showHidePassword('ChangePasswordNewMain2', 'iconPassMain2', 2)"></i>
                        <input type="password" v-model="new_password2" id="ChangePasswordNewMain2"
                            class="form-control change-password-toggle change-password-input modal-clear-val"
                            maxlength="16">
                        <label for="ChangePasswordNewMain2" class="">Ingrese Nuevamente</label>
                    </div>
                    <div v-if="changePasswordMessage.message != ''" class="font-size-custom text-center pb-4"
                        id="ChangePasswordError" style="display: block;"
                        :style="changePasswordMessage.type == 'error' ? 'color:red;' : 'color:green;'">{{
                            changePasswordMessage.message }}</div>
                    <div class="col modal-clear-hide text-center text-center mb-4" id="ChangePasswordLoadingMain"
                        style="display: none;">
                        <div class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-green-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-center py-2">
                    <input type="hidden" class="modal-clear-val" id="ChangePasswordId" value="146675">
                    <input type="hidden" class="modal-clear-val" id="ChangePasswordRole" value="affiliate">
                    <button type="button" class="btn btn-outline-cyan px-3 waves-effect waves-light" data-dismiss="modal"
                        @click="closeModal">Cerrar</button>
                    <button type="button" class="btn btn-cyan px-3 waves-effect waves-light waves-light"
                        id="ModalChangePasswordSubmitMain" @click="changePassword">Aceptar</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade show" id="ModalNewTicket" tabindex="-1" role="dialog" aria-labelledby="NewTicket"
        aria-modal="true">
        <div class="modal-dialog modal-dialog-scrollable cascading-modal modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header text-center gradient-card-header blue-gradient">
                    <h6 class="modal-title w-100 font-weight-bold text-left ml-2">Contactar a Soporte</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body modal-body-custom">
                    <div v-if="loading" style="width:100%" class="text-center p-2">
                        <div class="spinner-border" style="color:rgb(109, 179, 255)" role="status">
                        </div>
                    </div>
                    <div v-else>
                        <div class="col-10 offset-2 md-form mb-5 chat-body white z-depth-1 font-size-custom">
                            <input v-model="support_subject" type="text" id="ModalNewTicketSubject" class="form-control new-ticket-input modal-clear-val"
                                autocomplete="off" maxlength="64">
                            <label class="ml-3" for="ModalNewTicketSubject">Asunto</label>
                        </div>
                        <div class="d-flex">
                            <div class="col-2 md-form px-0 file-field" id="ModalNewTicketAttachDiv">
                                <div class="btn btn-floating blue-gradient float-left waves-effect waves-light my-0">
                                    <i class="fas fa-paperclip" aria-hidden="true" @click="triggerImageUpload"></i>
                                    <input type="file" ref="imageInput" @change="handleImageUpload" style="display: none;" accept="image/*">
                                </div>
                                <div class="font-size-custom pt-5" id="ModalNewTicketAttachCount"><span></span> imagen/es</div>
                            </div>
                            <div class="col-10 md-form amber-textarea active-amber-textarea mt-3 chat-body white z-depth-1 font-size-custom"
                                id="ModalNewTicketReply">
                                <textarea v-model="support_message" id="ModalNewTicketMessage" class="md-textarea form-control" rows="3"></textarea>
                                <label class="ml-3" for="ModalNewTicketMessage">Ingrese aqui el mensaje</label>
                            </div>
                        </div>
                    </div>
                    <div class="p-0" style="text-align: end;"><span style="font-size: x-small;">{{ support_image }}</span></div>
                </div>
                <div class="modal-footer justify-content-center py-2">
                    <input type="hidden" class="input-clear-val" id="ModalNewTicketProviderId" value="">
                    <input type="hidden" class="input-clear-val" id="ModalNewTicketTransactionId" value="">
                    <button type="button" class="btn btn-outline-cyan px-3 waves-effect waves-light" data-dismiss="modal"
                        @click="closeModal">Cancelar</button>
                    <button @click="createTicket" type="button" :disabled="loading || support_message ==''" class="btn btn-cyan px-3 waves-effect waves-light"
                        id="ModalNewTicketSubmit">Enviar</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade show" id="ModalReplyTicket" tabindex="-1" role="dialog" aria-labelledby="ReplyTicket" aria-modal="true">
        <div class="modal-dialog modal-dialog-scrollable cascading-modal modal-md" role="document">
            <div class="modal-content"  style="max-height: 70vh;">
                <div class="modal-header text-center gradient-card-header blue-gradient">
                    <h6 class="modal-title w-100 font-weight-bold text-left ml-2">Respuesta de soporte</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body modal-body-custom">
                    <div v-if="loading" style="width:100%" class="text-center p-2">
                        <div class="spinner-border" style="color:rgb(109, 179, 255)" role="status">
                        </div>
                    </div>
                    <div v-else class="col-12 px-0 pt-3">
                        <div class="chat-message">
                            <ul v-if="supportTicketTarget.descripcion" class="list-unstyled chat" style="display: block;">
                                <li v-for="(message, index) in JSON.parse(supportTicketTarget.descripcion)" :key="index">
                                    <div v-if="message.sender==main_tree.user_name" class="d-flex justify-content-between mb-4">
                                        <div class="col-2"></div>
                                        <div class="col-10 chat-body chat-own-message white p-2 mr-2 z-depth-1">
                                            <div class="header"><strong>{{ message.sender }}</strong></div>
                                            <p class="mb-0">{{ message.message }}</p>
                                            <p v-if="message.image">
                                                <img :src="message.image" alt="" style="max-width: 250px">
                                            </p>
                                            <div class="d-flex">
                                                <div class="gallery gallery0"></div>
                                                <small class="float-right">
                                                    <svg
                                                        class="message-check" data-message-id="0"
                                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15" width="16"
                                                        height="15">
                                                        <path :fill="message.leido_gplus_uid == 0 ? '#4FC3F7' : 'grey'"
                                                            d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z">
                                                        </path>
                                                    </svg> {{ formatearFecha(message.date) }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="d-flex justify-content-between mb-4">
                                        <div class="col-10 chat-body white p-2 z-depth-1">
                                            <div class="header"><strong>{{ message.sender }}</strong></div>
                                            <hr class="w-100">
                                            <p class="mb-0">{{ message.message }}<br>
                                            </p>
                                            <p v-if="message.image">
                                                <img :src="message.image" alt="" style="max-width: 250px">
                                            </p>
                                            <div class="d-flex">
                                                <div class="gallery gallery2" style="height:15px"></div><small class="float-right"> {{ formatearFecha(message.date) }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="col modal-clear-hide text-center text-center mb-4" id="ModalReplyTicketLoading"
                                style="display: none;">
                                <div class="preloader-wrapper small active">
                                    <div class="spinner-layer spinner-green-only">
                                        <div class="circle-clipper left">
                                            <div class="circle"></div>
                                        </div>
                                        <div class="gap-patch">
                                            <div class="circle"></div>
                                        </div>
                                        <div class="circle-clipper right">
                                            <div class="circle"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col modal-clear-hide text-center text-center mt-1" id="ModalReplyTicketError"
                                style="display: none;">Se pueden adjuntar hasta 5 imagenes</div>                
                        </div>
                    </div>
                </div>
                <div class="justify-content-center px-2">
                    <div class="d-flex">
                        <div class="col-2 md-form px-0 file-field" id="ModalReplyTicketAttachDiv"
                            style="display: block;">
                            <div class="btn btn-floating blue-gradient float-left waves-effect waves-light my-0">
                                <i class="fas fa-paperclip" aria-hidden="true" @click="triggerImageUpload"></i>
                                <input type="file" ref="imageInput" @change="handleImageUpload" style="display: none;" accept="image/*">
                            </div>
                            <div class="font-size-custom pt-5" id="ModalReplyTicketAttachCount"
                                style="display: none;"><span></span> imagen/es</div>
                        </div>
                        <div class="p-0 col-10 md-form amber-textarea active-amber-textarea mt-3 chat-body white z-depth-1 font-size-custom"
                            id="ModalReplyTicketReply" style="display: block;">
                            <textarea v-model="support_message" id="ModalReplyTicketMessage" class="md-textarea form-control"
                                rows="2"></textarea>
                            <label class="ml-3" for="ModalReplyTicketMessage">Respuesta</label>
                        </div>
                    </div>
                    <div class="p-0" style="text-align: end;"><span style="font-size: x-small;">{{ support_image }}</span></div>
                    <div class="text-center">
                        <button type="button" class="btn btn-outline-cyan px-3 waves-effect waves-light"
                        data-dismiss="modal" @click="closeModal">Cerrar</button>
                    <button @click="replyTicket" :disabled="loading || support_message ==''" type="button" class="btn btn-cyan px-3 waves-effect waves-light"
                        id="ModalReplyTicketSubmit">Responder</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div style="display: none;">{{ main_tree }}</div> -->
    <div id="modalBackdrop" class="modal-backdrop fade" style="display: none;"></div>
    <div id="modalBackdropMovil" class="modal-backdrop fade" style="display: none;z-index: 8;" @click="closeNav"></div>
    </div>
</template>
<script>
// import stats from './dashboard_components/stats'
import reporteAgente from './dashboard_components/reporteAgente'
import router from '../router/index';
import axios from 'axios';
export default {
    name: 'DashboardPage',
    components: {
        // stats,
        reporteAgente,
    },
    data() {
        return {
            slim: "",
            logo: process.env.VUE_APP_LOGO,
            reloadCharts: 0,
            viewType: "thin",
            hideArrows: false,
            new_password: "",
            screen_width: 0,
            new_password2: "",
            showPassword: false,
            showPassword2: false,
            changePasswordMessage: { type: "", message: "" },
            support_subject:"",
            support_message:"",
            support_image:"",
            support_image_src: "",
            supportTickets:[],
            supportTicketTarget:{},
            loading:false,
            treeLoaded:false
        }
    },
    methods: {
        logout(){
            this.$store.dispatch("logOut")
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        reload() {
            this.reloadCharts++;
        },
        sizeControl() {
            this.screen_width = window.innerWidth;
        },
        changeView: function (view) {
            this.$store.dispatch('setDashboardView', view);
            if (this.screen_width < 1000) {
                this.closeNav()
            }
        },
        openNav(){
            document.getElementById("mySidenav").style.width = "250px";
            if (this.screen_width < 1000) {
                document.getElementById("modalBackdropMovil").style.display = "block";
                document.getElementById("modalBackdropMovil").classList.add("show");
            }
            else{
                this.hideArrows = false
                this.viewType = "thin"
            }
        },
        closeNav() {
            document.getElementById("mySidenav").style.width = "0";
            if (this.screen_width < 1000) {
                document.getElementById("modalBackdropMovil").style.display = "none";
                document.getElementById("modalBackdropMovil").classList.remove("show");
            }
            else{
                document.getElementById("mySidenav").style.width = "60px";
                this.hideArrows = true
                this.viewType = "wide"
            }
        },
        async changePassword() {
            try {
                document.getElementById("ChangePasswordLoadingMain").style.display = "block";
                document.getElementById("ModalChangePasswordSubmitMain").disabled = true;
                let response = await axios.post(process.env.VUE_APP_DATA_SERVER_URL + "/cambiar_password", {
                    "users": [this.UserData.id],
                    "password": this.new_password,
                    "password1": this.new_password2,
                    "token": this.UserData.token,
                    "login_id": this.main_tree.id
                }
                )
                if (response.data) {
                    this.changePasswordMessage = {
                        message: response.data.message ?? response.data.error,
                        type: response.data.message ? 'success' : 'error'
                    };
                    document.getElementById("ChangePasswordLoadingMain").style.display = "none";
                    document.getElementById("ModalChangePasswordSubmitMain").disabled = false;
                }
            } catch (error) {
                console.log(error.message);
                document.getElementById("ChangePasswordLoadingMain").style.display = "none";
                document.getElementById("ModalChangePasswordSubmitMain").disabled = false;
            }
        },
        openModal(target,ticket) {
            try {
                this.backdrop(true);
                let modal = document.getElementById(target);
                modal.classList.add("show");
                modal.style.display = "block";
                if (target == 'historial_ingresos') {
                    this.getIngresos()
                }
                if(ticket){
                    this.supportTicketTarget = ticket
                    this.readTicket(ticket)
                }
            } catch (error) {
                console.log(error);
            }
        },
        showHidePassword(target, icon, flag) {
            if (flag == 1 && !this.showPassword) {
                document.getElementById(target).type = "text";
                document.getElementById(icon).classList.remove("fa-eye");
                document.getElementById(icon).classList.add("fa-eye-slash");
                this.showPassword = true
            }
            else if (flag == 1 && this.showPassword) {
                document.getElementById(target).type = "password";
                document.getElementById(icon).classList.remove("fa-eye-slash");
                document.getElementById(icon).classList.add("fa-eye");
                this.showPassword = false
            }
            if (flag == 2 && !this.showPassword2) {
                document.getElementById(target).type = "text";
                document.getElementById(icon).classList.remove("fa-eye");
                document.getElementById(icon).classList.add("fa-eye-slash");
                this.showPassword2 = true
            }
            else if (flag == 2 && this.showPassword2) {
                document.getElementById(target).type = "password";
                document.getElementById(icon).classList.remove("fa-eye-slash");
                document.getElementById(icon).classList.add("fa-eye");
                this.showPassword2 = false
            }
        },
        backdrop(action) {
            if (action) {
                document.getElementById("modalBackdrop").style.display = "block";
                document.getElementById("modalBackdrop").classList.add("show");
            }
            else {
                document.getElementById("modalBackdrop").style.display = "none";
                document.getElementById("modalBackdrop").classList.remove("show");
            }
        },
        closeModal() {
            let modals = document.getElementsByClassName("modal");
            [...modals].forEach(modal => {
                modal.classList.remove("show");
                modal.style.display = "none";
            })
            document.getElementById("modalBackdrop").style.display = "none";
            document.getElementById("modalBackdrop").classList.remove("show");
            this.new_password = "";
            this.new_password2 = "";
            this.support_subject="";
            this.support_message="";
            this.support_image="";
            this.support_image_src= "";
            this.changePasswordMessage = { type: "", message: "" }
        },
        showPasswordChangeSecurity() {
            setTimeout(() => { this.openModal('ModalChangePassword1') }, 2000)
        },
        async getSupportTickets(){
            let tickets = await axios.post(process.env.VUE_APP_DATA_SERVER_URL +"/estado_soporte", {
                "login_Id": this.main_tree.id
            })
            if(tickets.data){
                this.supportTickets = tickets.data;
            }
        },
        countDays(init){
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        async createTicket(){
            this.loading = true
            await axios.post(process.env.VUE_APP_DATA_SERVER_URL +"/soporte", {
                "asunto":  this.support_subject,
                "descripcion": this.support_message,
                "login_Id": this.main_tree.id,
                "estado":  1, 
                "image": this.support_image_src,
                "gplus_uid":1001
            })
            this.loading = false
            this.support_subject = "";
            this.support_message = "";
            this.support_image = "";
            this.support_image_src = "";
            this.getSupportTickets()
            this.closeModal()
        },
        async replyTicket(){
            this.loading = true
            await axios.post(process.env.VUE_APP_DATA_SERVER_URL +"/respuesta_soporte", {
                "ticket":  this.supportTicketTarget.id,
                "descripcion": this.support_message,
                "image": this.support_image_src,
                "login_Id": this.main_tree.id,
                "estado":  1
            })
            this.loading = false
            this.support_subject = "";
            this.support_message = "";
            this.support_image = "";
            this.support_image_src = "";
            this.getSupportTickets()
            this.closeModal()
        },
        triggerImageUpload() {
            this.$refs.imageInput.click();  // Activa el input de tipo "file"
        },
        compressImage(imgToCompress, resizingFactor = 0.3, quality = 0.5) {
            // resizing the image
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            
            const originalWidth = imgToCompress.width;
            const originalHeight = imgToCompress.height;
            
            const canvasWidth = originalWidth * resizingFactor;
            const canvasHeight = originalHeight * resizingFactor;
            
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            
            context.drawImage(
                imgToCompress,
                0,
                0,
                originalWidth * resizingFactor,
                originalHeight * resizingFactor
            );
            
            // reducing the quality of the image
            const self = this;
            canvas.toBlob(
                (blob) => {
                if (blob) {
                    var reader = new FileReader();
                    reader.readAsDataURL(blob); 
                    reader.onloadend = function() {
                        var base64data = reader.result;      
                        self.support_image_src = base64data; // AQUI ESTA EL BASE 64 RESULTANTE
                    }
                }
                },
                "image/jpeg",
                quality
            );
        },
        handleImageUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                // Aquí reducimos la calidad de la imagen antes de convertirla en Data URL
                const image = new Image();
                image.src = e.target.result;
                // console.log(file.name)
                this.support_image = file.name;
                const self = this;
                image.onload = () => {
                    self.compressImage(image)
                };
                };
                reader.readAsDataURL(file);
            }
        },
        async readTicket(ticket){
            console.log(ticket.leido_padre,ticket.padre,this.main_tree.id);
            if((ticket.leido_user_creacion==1 && ticket.user_creacion == this.main_tree.id) || (ticket.leido_padre==1 && ticket.padre == this.main_tree.id)){
                console.log("ticket read");
                await axios.post(process.env.VUE_APP_DATA_SERVER_URL +"/leido_soporte", {
                    "login_Id": this.main_tree.id,
                    "ticket": this.supportTicketTarget.id
                })
                this.getSupportTickets();
            }
        },
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
        isTreeLoaded(){
            this.treeLoaded = true;
        }
    },
    computed: {
        showChangePassword() {
            if (this.$store.getters['getShowChangePassword']) {
                this.showPasswordChangeSecurity()
            }
            return this.$store.getters['getShowChangePassword'];
        },
        reloadStats() {
            return this.$store.getters["getRenderStats"];
        },
        getActualView() {
            return this.$store.getters['getDashboardView'];
        },
        UserData() {
            return this.$store.getters["getUserData"];
        },
        main_tree() {
            let data = this.$store.getters["getMainTree"]
            if(data.id){
                this.isTreeLoaded();
            }
            return data;
        },
    },
    created() {
        this.sizeControl();
        if (localStorage.getItem("loginToken") && !this.UserData.token) {
            this.$store.dispatch("login", { token: localStorage.getItem("loginToken") })
        }
        else if (this.$store.getters["getUserData"].token == "") {
            router.push({ name: 'login' })
        }
    },
    mounted() {
        if (this.screen_width > 1000) {
            this.openNav()
        }
        else {
            this.closeNav()
        }
        window.addEventListener('resize', () => { this.sizeControl(); });
    },
    watch:{
        treeLoaded(newVal,oldVal){
            if(newVal != oldVal && newVal){
                this.getSupportTickets();
            }
        }
    }
}
</script>
<style scoped>
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.5s;
}
.sidenav ul {
    list-style: none;
    padding-left: 0;
}
.sidenav>ul {
    max-height: 100vh;
}
.sidenav .fa-angle-right {
    position: absolute;
    right: 0;
    top: 0.8rem;
    margin-right: 1.25rem!important;
}
.sidenav.wide .fa-angle-down.rotate-icon {
    opacity: 1;
    display: block;
}

.sidenav .fa-angle-down.rotate-icon {
    position: absolute;
    right: 0;
    top: 0.8rem;
    margin-right: 1.25rem;
}
a {
    color: black !important;
    display: block;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    transition: 0.3s;
}
.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}
</style>
  